import * as React from "react";
import { Step, Question } from ".";

// The same questions as in the original Step1Page
const questions: Question[] = [
    {
        question: "Pourquoi est-il essentiel d’entrer votre séance de tutorat sur le portail à la fin, et non au début ?",
        answers: [
            "Pour permettre aux élèves-athlètes de voir leur progrès en direct et ajuster leur comportement.",
            "Parce que cela évite les oublis liés à la planification en amont et permet une gestion optimale des présences.",
            "Parce que cela garantit que le tuteur pourra évaluer objectivement le déroulement de la séance avant de consigner l’information, ce qui facilite un suivi juste et cohérent par les coordonnateurs.",
            "Pour des raisons techniques liées à l’enregistrement automatique des données en ligne par la plateforme."
        ],
        correctAnswer: 2,
        explanation: "Entrer la séance à la fin permet de confirmer que la séance a bel et bien eu lieu, d’y ajouter des commentaires justes, basés sur ce qui s’est réellement passé, de garantir une traçabilité utile pour les coordonnateurs (gestion des présences, suivi des difficultés, validation des temps de jeu, etc.). Les autres choix peuvent sembler partiellement logiques, mais ils manquent de précision ou sont secondaires."
    },
];


export function Step6Page() {
    return (
        <Step
            stepNumber="6"
            title="Sixième capsule"
            videoUrl={`${process.env.PUBLIC_URL}/assets/formation-videos/video6.mp4`}
            redirectURL="/formation/completed"
            questions={questions}
        />
    );
} 